import { createAction } from '@reduxjs/toolkit';

import { PUBNUB } from 'store/constants/actions';

import { IPubnubSetPubNubAuth } from 'store/types/actions';

export const setNamespace = createAction<string | null>(PUBNUB.SET_NAMESPACE);
export const setNotification = createAction<string | null>(PUBNUB.SET_NOTIFICATION);
export const setPubNubAuth = createAction<IPubnubSetPubNubAuth>(PUBNUB.SET_PUBNUB_AUTH);
